"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
const Filter_1 = require("./Filter");
class Query {
    constructor(nodes) {
        this.all = new Set();
        this.added = new Set();
        this.removed = new Set();
        this.unchanged = new Set();
        this.writer = (() => {
            const query = this;
            function add(entity) {
                if (query.matches(entity) && !query.all.has(entity)) {
                    query.all.add(entity);
                    query.added.add(entity);
                }
            }
            function update(entity) {
                if (query.matches(entity)) {
                    if (!query.all.has(entity)) {
                        query.all.add(entity);
                        query.added.add(entity);
                    }
                }
                else
                    remove(entity);
            }
            function remove(entity) {
                query.all.delete(entity);
                query.added.delete(entity);
                query.unchanged.delete(entity);
                if (query.matches(entity))
                    query.removed.add(entity);
            }
            function flush() {
                for (const entity of query.added) {
                    query.unchanged.add(entity);
                }
                query.added.clear();
                query.removed.clear();
            }
            return { add, update, remove, flush };
        })();
        this.reader = (() => {
            const query = this;
            function has(entity) {
                return query.all.has(entity);
            }
            return {
                get count() { return query.all.size; },
                all: query.all,
                added: query.added,
                removed: query.removed,
                unchanged: query.unchanged,
                has
            };
        })();
        this.filter = Filter_1.And(...nodes);
    }
    matches(entity) {
        return this.filter.filterFn(entity);
    }
}
exports.Query = Query;
